import { BacksolveSourceRow } from 'api';

const computeSourceRowsTotals = (sourceRows: BacksolveSourceRow[]) => {
  const weightedTargetPrice = sourceRows.reduce(
    (sum, row) => sum + Number(row.price_per_share ?? 0) * Number(row.weighting ?? 0),
    0,
  );
  const totalWeighting = sourceRows.reduce((sum, row) => sum + Number(row.weighting ?? 0), 0);

  return { weightedTargetPrice, totalWeighting };
};

export default computeSourceRowsTotals;
